import { createContext, type ReactNode, useContext } from 'react';
import type { Services } from './services';

export interface CoreConfig {
  services: Services;
  /** Current UI language; part of query keys so names refetch in the new language. */
  locale: string;
  /** Client-generated ids for idempotent creates (crypto.randomUUID on web, expo-crypto on mobile). */
  newId(): string;
}

const CoreContext = createContext<CoreConfig | null>(null);

export function CoreProvider({ value, children }: { value: CoreConfig; children: ReactNode }) {
  return <CoreContext.Provider value={value}>{children}</CoreContext.Provider>;
}

export function useCore(): CoreConfig {
  const value = useContext(CoreContext);
  if (!value) throw new Error('useCore() needs <CoreProvider>');
  return value;
}
